import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostYtdSummaryRequestSchema,
  TPostYtdSummaryResponseSchema,
} from "./postYtdSummarySchema";

const URL = `reports/ytd`;
export const postYtdSummary = (axios: IAxiosInstance) => {
  return async (requestBody: TPostYtdSummaryRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TPostYtdSummaryResponseSchema>
    >(URL, requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
